import { CountriesQuery, CountriesQueryVariables } from "@ctypes";
import { COUNTRIES } from "@graphql";
import { useQuery } from "@hooks/apollo";

export const useCountries = () => {
  return useQuery<CountriesQuery, CountriesQueryVariables>(COUNTRIES);
};
